module.exports = "/src/views/player/help/images/barb2.jpg";